(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderIntegrationDeleteController',LenderIntegrationDeleteController);

    LenderIntegrationDeleteController.$inject = ['$uibModalInstance', 'entity', 'LenderIntegration'];

    function LenderIntegrationDeleteController($uibModalInstance, entity, LenderIntegration) {
        var vm = this;

        vm.lenderIntegration = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LenderIntegration.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
